/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useContext } from 'react';
import { provider, auth } from 'services/firebase';
import { AuthContext } from 'context/AuthContext';
import { useHistory } from 'react-router-dom';
import { LOGIN, MESSAGES } from 'constants/routes';

interface AuthHookResponse {
  signInWithGoogle: () => void;
  signOut: () => void;
}

const useAuth = (): AuthHookResponse => {
  const history = useHistory();
  const authContext = useContext(AuthContext);
  const { dispatchSignInSuccess, dispatchSignInFailure } = authContext;

  const dispatchSignOut = (): void => {
    dispatchSignInFailure();
    history.push(LOGIN);
  };

  const signInWithGoogle = (): void => {
    auth
      .signInWithPopup(provider)
      .then(async (result) => {
        return auth.currentUser
          ?.getIdTokenResult()
          .then((idTokenResult) => {
            if (idTokenResult.claims.admin) {
              dispatchSignInSuccess(result.user!);
              history.push(MESSAGES);
            } else {
              signOut();
            }
          })
          .catch(() => dispatchSignOut());
      })
      .catch(() => dispatchSignOut());
  };

  const signOut = (): void => {
    auth.signOut().then(() => dispatchSignOut());
  };

  return { signInWithGoogle, signOut };
};

export default useAuth;
